var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-header"}),_c('div',{staticClass:"page-body"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }